<template>
  <div v-if="run" class="first-run-strip" data-test="first-run-strip">
    Saved: <b>{{ run.keyword }}</b> on <span class="first-run-strip__url">{{ run.url }}</span>. Your first report runs right after checkout.
  </div>
</template>

<script>
import { pendingFirstRun } from './first-run'

// Confirmation pill on the plan pages while a "Run this on your page" intent is saved.
export default {
  name: 'FirstRunIntentStrip',
  computed: {
    run() {
      return pendingFirstRun(this.$store)
    },
  },
}
</script>

<style scoped lang="scss">
@import './auth-tokens.scss';

.first-run-strip {
  position: fixed; top: 16px; left: 50%; transform: translateX(-50%); z-index: 90;
  display: flex; gap: 6px; align-items: center; max-width: calc(100vw - 32px);
  background: $pop-teal; color: #fff; border-radius: 10px; padding: 10px 16px; font-size: 13px;
  box-shadow: 0 10px 30px rgba(1, 71, 81, 0.3);

  &__url { opacity: 0.8; max-width: 260px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}
</style>
